// extracted by css-extract-rspack-plugin
export default {"select":"PerPage__select--vBFVt"};